import { processingSessionItemIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";
import {
  ItemProcessingStatusSchema,
  ProcessingSession,
} from "./processing-session";

export const updateProcessingSessionItem = {
  name: "updateProcessingSessionItem" as const,
  input: z.object({
    sessionItemId: processingSessionItemIdFormat.schema,
    status: ItemProcessingStatusSchema.optional(),
    grade: z.string().nullish(),
    outcome: z.string().nullish(),
    notes: z.string().nullish(),
  }),
  output: z.object({ session: ProcessingSession }),
};
